<template>
  <div>
    <a-spin size="large" :spinning="spinning" :indicator="indicator">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <!-- <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          > -->
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        row-id="id"
        size="small"
        ref="xTable"
        :data="tableData_detable"
        align="center"
        header-align="center"
      >
        <vxe-column
          field="datasetID"
          title="Dataset ID"
          width="150px"
          type="html"
        >
          <!-- <template #default="{ row }">
            <a
              @click="goBulkPerturbgene(row.datasetID, row.genename)"
              style="color: blue"
              >{{ row.datasetID }}</a
            >
          </template> -->
        </vxe-column>
        <vxe-column
          field="genename"
          title="Perturbed gene"
          type="html"
        ></vxe-column>
        <vxe-column field="ensgID" title="Ensembl ID" type="html"></vxe-column>
        <vxe-column field="cell" title="Cell Line" type="html"></vxe-column>
        <vxe-column field="method" title="Method" type="html"></vxe-column>
        <!-- <vxe-column field="nsample" title="No. sample" type="html"></vxe-column> -->
        <vxe-column field="accession" title="DEGs" type="html">
          <template #default="{ row }">
            <a-icon
              :style="{ color: 'blue', fontSize: '20px' }"
              type="cloud-download"
              @click="downloadSeurat(row.datasetID)"
            /> </template
        ></vxe-column>
        <template #empty>
          <span> No more data! </span>
        </template>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[20, 50, 100]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  props: ["choosepathway"],
  data() {
    return {
      //相关性分析
      corModal: false,
      gene1: "",
      gene2: this.$route.query.gene,
      //加载
      spinning: true,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
      },
    };
  },
  created() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/bulkseq.php")
      .then((response) => {
        this.getdata_detable = response.data;
        this.findList_detable(this.getdata_detable);
        this.spinning = false;
      });
  },

  methods: {
    // 下载 DEGs文件
    downloadSeurat(id) {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");

      link.style.display = "none";

      // 设置文件的下载链接

      link.href =
        "http://research.gzsys.org.cn/perturbdb/data/Bulkseq/DE/" +
        id.replace("BK", "BC") +
        ".de.txt";

      link.setAttribute("download", "PerturbDB_" + id + ".DEGs.txt");

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "PerturbDB_all_BulkSeq",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename: this.filterName_detable + "_related_BulkSeq",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    handleOk() {
      this.corModal = false;
    },
    handleCancel() {
      this.corModal = false;
    },
    goBulkPerturbgene(value, vaule2) {
      //   console.log(value);
      //   this.corModal = true;
      //   this.gene1 = value;
      let href =
        "http://research.gzsys.org.cn/perturbdb/#/bulkseq?datasetID=" +
        value +
        "&gene=" +
        vaule2;
      window.open(href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = [
          "datasetID",
          "genename",
          "ensgID",
          "cell",
          "method",
          "accession",
        ];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
</style>
